import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
// import DeleteIcon from '@mui/icons-material/Delete';
import GlobalContext from '../../../contexts';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import useSort from '../../../hooks/useSort';
import useFetchData from '../../../hooks/useFetchData';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SnackBar from 'components/SnackBar';
import translating from '../translate.json';

const TerapistsList = () => {
  const navigate = useNavigate();
  const { categoriesList, regionEnum, setLink, currentUser } =
    useContext(GlobalContext);
  const [filteredTerapists, setFilteredTerapists] = useState([]);
  const { showFilters, toggle } = useSort();
  const { data: terapistsData, loading } = useFetchData(
    'user/therapist/findAll'
  );
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  useEffect(() => {
    if (terapistsData?.length) setFilteredTerapists(terapistsData);
    console.log(terapistsData);
  }, [terapistsData]);

  const actionsCustomersList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: 'עריכה',
      handleClickAction: () => {
        showFilters && setFilteredTerapists(terapistsData);
        toggle(!showFilters);
      }
    }
  ];

  // const handleDeleteItem = () => {
  //   console.log('delete icon clicked')
  // }

  const tableHeaders = [
    translating.terapistName,
    translating.terapistNum,
    // translating.terapistPhone,
    translating.terapistMobile,
    translating.terapistRegion,
    translating.terapistAddress,
    translating.terapistEmail,
    translating.terapistDomain,
    translating.sumOfTerapists,
    translating.createdDate,
    translating.status
  ];

  const columns = [
    { value: 'full_name', bold: true, sort: true },
    { value: 'ssn', sort: true },
    // { value: 'phone' },
    { value: 'mobile', sort: true },
    { value: 'region', sort: true },
    { value: 'address', sort: true },
    { value: 'email', sort: true },
    { value: 'categoryName', sort: true },
    { value: 'number_of_patients', bold: true, sort: true },
    { value: 'createdAt', format: 'date', sort: true },
    { value: 'isActive', sort: true, format: 'status' }
    // { value: '', icon: DeleteIcon, handleAction: handleDeleteItem }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['full_name', 'last_name', 'email', 'ssn']
    },
    {
      type: 'select',
      label: translating.terapistDomain,
      name: 'categoryId',
      options: categoriesList,
      isId: true
    },
    {
      type: 'select',
      label: translating.terapistRegion,
      name: 'region',
      options: regionEnum
    },
    {
      type: 'select',
      label: translating.status,
      name: 'isActive',
      options: [
        { id: 'true', name: 'פעיל' },
        { id: 'false', name: 'חסום' }
      ],
      isId: true
    }
  ];

  const onFilter = (filteredData) => {
    setFilteredTerapists(filteredData);
  };

  const onResetFilters = () => {
    setFilteredTerapists(terapistsData);
  };

  const roleUser = currentUser.role.name;
  const allowdRules = ['Admin', 'System', 'Manager', 'Service'];
  const createNewTherapist =
    allowdRules.indexOf(roleUser) > -1
      ? { handleClick: () => setLink('add') }
      : {};

  return (
    <div className="terapists-list">
      <ListHeader
        title={translating.terapistListTitle}
        actions={actionsCustomersList}
        newItem={createNewTherapist}
      ></ListHeader>
      {showFilters && categoriesList?.length && (
        <Filter
          fields={sortFields}
          data={terapistsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="terapists-list-wrapper-table">
        <div className="count-clients">{`נמצאו ${filteredTerapists?.length} מטפלים `}</div>
        {terapistsData && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredTerapists}
            pagination={true}
            handleRowClick={(id, e, row) => {
              navigate(`/therapists/${row.user_uuid}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'מטפל נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default TerapistsList;
